import React, { useContext } from 'react';
import constants from '../../../../../common/constants';
import { CodeRepoFormCtx } from './CodeRepoFormContext';
import { InputFormField } from './InputFormField';
import { inputLengthValidation, requiredFieldValidation } from './Validations';

export const TitleFormField = () => {
  // @ts-expect-error TS2339 - strict migration
  const { repoData } = useContext(CodeRepoFormCtx);
  const validations = [requiredFieldValidation, inputLengthValidation];
  const updateTitle = (newValue: string) => ({ title: newValue });
  return (
    <InputFormField
      fieldId="title"
      label="Title*"
      placeholder={constants.CODE_REPO_TITLE_PLACEHOLDER}
      value={repoData.title}
      setValue={updateTitle}
      validations={validations}
    />
  );
};
